/* globals angular */
(function () {
  'use strict';

  //TODO: DEPRECATED
  function TermsService ($resource, URLAPICLIENTE) {
    return $resource(URLAPICLIENTE, {}, {
      accept: {
        method: 'POST',
        url: URLAPICLIENTE + '/clientes/:userId/contratos/aceiteTermoContrato',
        params: {
          userId:'@userId',
        },
      },
      accept_update: {
        method: 'POST',
        url: URLAPICLIENTE + '/clientes/:userId/contratos/aceite-atualizacao-termo-contrato',
        params: {
          userId:'@userId',
        },
      },

    });
  }
  angular
    .module('mandaeApp')
    .factory('TermsService', TermsService);
}());
